import { Tooltip } from 'component-library';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { AppContext } from '../../../contexts/AppContext';
import { Item, LatestSoftwareVersion, SystemDetail } from '../../../models/ApiModels';
import SystemDetailsSoftwareVersion from './SystemDetailsConfiguration/SystemDetailsSoftwareVersion';

interface Props {
  system: SystemDetail;
  latestSoftwareVersion?: LatestSoftwareVersion;
}

export default function SystemDetailsHardwareInterceptors(props: Props) {
  const { isHumphreeUser } = useContext(AppContext);
  const navigate = useNavigate();
  const items: Item[] = useSelector((state: any) => state.configurations.items);
  return (
    <div className='border-b border-gray-10'>
      <div className='flex gap-2 my-3'>
        <span className='prose-heading5'>Lightning interceptors</span>
        <Tooltip description='The interceptors are installed on the transom of the boat to optimize the boating experience with the selected functionalities.' />
      </div>
      <div className='xl:flex xl:justify-between my-5 items-center'>
        <div className='xl:font-normal font-semibold w-48'>Port</div>
        <div className='2xl:gap-16 xl:flex gap-4'>
          <div className='w-32 flex justify-between items-center truncate'>
            {
              items.find(
                (item: Item) =>
                  props.system.lightningHardwareSystem?.portServo?.articleNumber?.slice(0, 6) === item.articleNumber
              )?.displayName
            }
          </div>
          {props.system.lightningHardwareSystem?.portServo?.articleNumber && (
            <div className='xl:w-42 flex justify-between items-center'>
              Part no.
              <span className='font-code prose-dataBaseDataLabel ml-3'>
                {props.system.lightningHardwareSystem?.portServo?.articleNumber}
              </span>
            </div>
          )}
          {props.system.lightningHardwareSystem?.portServo?.serialNumber && (
            <div className='xl:w-32 flex justify-between items-center'>
              Serial no.
              <span className='font-code prose-dataBaseDataLabel ml-3'>
                {isHumphreeUser ? (
                  <Link
                    to={'/units/lsu/' + props.system.lightningHardwareSystem?.portServo?.serialNumber}
                    className='whitespace-nowrap cursor-pointer underline text-primary-100 hover:text-primary-200'
                  >
                    {props.system.lightningHardwareSystem?.portServo?.serialNumber?.toString()}
                  </Link>
                ) : (
                  props.system.lightningHardwareSystem?.portServo?.serialNumber?.toString()
                )}
              </span>
            </div>
          )}
          {props.system.lightningHardwareSystem?.portServo?.firmwareVersion && (
            <div className='xl:w-42 flex justify-between items-center'>
              Software
              <span className='font-code prose-dataBaseDataLabel ml-3 xl:w-12 xl:truncate'>
                {props.system.lightningHardwareSystem?.portServo?.firmwareVersion}
              </span>
            </div>
          )}
          <SystemDetailsSoftwareVersion
            latestSoftwareVersion={props.latestSoftwareVersion}
            unitType='LSUPort'
            system={props.system}
          />
        </div>
      </div>
      <div className='xl:flex xl:justify-between my-5 items-center'>
        <div className='xl:font-normal font-semibold w-48'>Starboard</div>
        <div className='2xl:gap-16 xl:flex gap-4'>
          <div className='flex w-32 justify-between items-center truncate'>
            {
              items.find(
                (item: Item) =>
                  props.system.lightningHardwareSystem?.starboardServo?.articleNumber?.slice(0, 6) ===
                  item.articleNumber
              )?.displayName
            }
          </div>
          {props.system.lightningHardwareSystem?.starboardServo?.articleNumber && (
            <div className='xl:w-42 flex justify-between items-center'>
              Part no.
              <span className='font-code prose-dataBaseDataLabel ml-3'>
                {props.system.lightningHardwareSystem?.starboardServo?.articleNumber}
              </span>
            </div>
          )}
          {props.system.lightningHardwareSystem?.starboardServo?.serialNumber && (
            <div className='xl:w-32 flex justify-between items-center'>
              Serial no.
              <span className='font-code prose-dataBaseDataLabel ml-3'>
                {isHumphreeUser ? (
                  <Link
                    to={'/units/lsu/' + props.system.lightningHardwareSystem?.starboardServo?.serialNumber}
                    className='whitespace-nowrap cursor-pointer underline text-primary-100 hover:text-primary-200'
                  >
                    {props.system.lightningHardwareSystem?.starboardServo?.serialNumber?.toString()}
                  </Link>
                ) : (
                  props.system.lightningHardwareSystem?.starboardServo?.serialNumber?.toString()
                )}
              </span>
            </div>
          )}
          <div>
            {props.system.lightningHardwareSystem?.starboardServo?.firmwareVersion && (
              <div className='xl:w-42 flex justify-between items-center'>
                Software
                <span className='font-code prose-dataBaseDataLabel ml-3 xl:w-12 xl:truncate'>
                  {props.system.lightningHardwareSystem?.starboardServo?.firmwareVersion}
                </span>
              </div>
            )}
          </div>
          <SystemDetailsSoftwareVersion
            latestSoftwareVersion={props.latestSoftwareVersion}
            unitType='LSUStarboard'
            system={props.system}
          />
        </div>
      </div>
    </div>
  );
}
